import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import CustomSelect from "components/form/custom-select";
import CurrencyInput from "components/form/currency-input";
import { formatPrice } from "utils/utils";
import Select from "react-select";

const PembayaranOrder = ({ initialData, onSuccess, onError, bookingData }) => {
    const API_URL = '/transaction';

    const [formData, setFormData] = useState({
        booking_id: bookingData?.id,
        transaction_date: initialData?.transaction_date || '',
        amount: initialData?.amount || '',
        payment_method_id: initialData?.payment_method_id || '',
        paid_by: initialData?.payed_by || '',
        note: initialData?.note || '',
    });

    const paidByOptions = [
        { value: 'customer', label: 'Customer' },
        { value: 'agent', label: 'Agent' },
    ];

    const { createData, loading: creatingData } = useCreateData(API_URL);

    const handleChange = useFormChangeHandler(setFormData);

    const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
        createData,
        onSuccess,
        onError
    );

    const handleBeforeSubmit = (e) => {
        e.preventDefault();
        console.log('transaction_date', formData?.transaction_date);

        const manipulatedData = {
            ...formData,
            payment_method_id: formData?.payment_method_id.value,
            transaction_date: formData?.transaction_date,
        };

        handleSubmit(manipulatedData, e);
    };

    return (
        <div className="container-fluid mt-4">
            {/* Form Cek Ketersediaan */}
            <div className="card mb-4">
                <div className="card-header">
                    <h5 className="mb-0 fs-4">Informasi Pembayaran</h5>
                </div>
                <div className="card-body">
                    <form onSubmit={handleBeforeSubmit}>
                        <div className="form-group mb-3">
                            <label htmlFor="phone" className="form-label">Catatan</label>
                            <input
                                type="text"
                                className={clsx("form-control", formError?.phone && 'is-invalid')}
                                id="phone"
                                placeholder="Masukkan catatan"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                disabled={isSubmitting}
                            />
                            {formError?.phone && <div className="invalid-feedback">{formError?.phone}</div>}
                        </div>
                        <div className="row">
                            <div className="form-group mb-3 col-lg-6">
                                <label htmlFor="transaction_date" className="form-label">Tanggal Bayar</label>
                                <input
                                    type="date"
                                    className={clsx("form-control", formError?.transaction_date && 'is-invalid')}
                                    id="transaction_date"
                                    name="transaction_date"
                                    value={formData?.transaction_date}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                />
                                {formError?.transaction_date && <div className="invalid-feedback">{formError?.transaction_date}</div>}
                            </div>
                            <div className="form-group mb-3 col-lg-6">
                                <label htmlFor="sesi_id" className="form-label">Metode Pembayaran</label>
                                <CustomSelect
                                    url="/payment-method"
                                    value={formData?.payment_method_id}
                                    onChange={(selectedOption) => setFormData({ ...formData, payment_method_id: selectedOption })}
                                    valueKey="id"   // Sesuaikan dengan format data
                                    labelKey="name" // Sesuaikan dengan format data
                                    placeholder="Pilih Metode Pembayaran"
                                    isDisabled={isSubmitting}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group mb-3 col-lg-6">
                                <label htmlFor="paid_by" className="form-label">Dibayar Oleh</label>
                                <Select
                                    options={paidByOptions}
                                    value={paidByOptions.find((option) => option.value === formData?.paid_by)}
                                    onChange={(selectedOption) => setFormData({ ...formData, paid_by: selectedOption?.value })}
                                    placeholder="Pilih Dibayar Oleh"
                                    isDisabled={isSubmitting}
                                />
                                {formError?.paid_by && <div className="invalid-feedback">{formError.paid_by}</div>}
                            </div>
                            <div className="col-lg-6">
                                <CurrencyInput
                                    name="amount"
                                    label="Jumlah"
                                    value={formData.amount}
                                    onChange={(e, rawValue) => handleChange({ target: { name: 'amount', value: rawValue } })}
                                    error={formError?.amount}
                                    placeholder="Rp. 0"
                                />
                            </div>
                        </div>
                        {/* Gunakan CurrencyInput di sini */}
                        {/* <CurrencyInput
                            name="price"
                            label="Jumlah"
                            value={formData.amount} // Bind value ke formData
                            onChange={(e, rawValue) => handleChange({ target: { name: 'amount', value: rawValue } })} // Simpan rawValue
                            error={formError?.amount} // Menampilkan error jika ada
                            placeholder="Rp. 0" // Placeholder Rupiah default
                        /> */}

                        <div className="d-flex justify-content-end">
                            <div className="mb-3">
                                <h3 className="fs-4">Sisa Pembayaran</h3>
                                <span className="d-flex justify-content-end">{formatPrice(bookingData?.sisa_pembayaran)}</span>
                            </div>
                        </div>

                        <div className="form-group d-grid">
                            <button type="submit" className="btn btn-primary btn-block" disabled={isSubmitting}>
                                {isSubmitting ? 'Menambahkan Pembayaran...' : 'Tambah Pembayaran'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PembayaranOrder;
